// Query options for Programs
import { queryOptions } from '@tanstack/react-query';
import { programsDashboardService } from '#client/services/programs/programServices.js';
import { SHARED_CONSTANTS } from '#shared/sharedConstants';

// Program Dashboard Query Options
export const programDashboardQueryOptions = {
    staleTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
};

export const getProgramsQueryOptions = (filters = {}, sortBy = 'createdAt', sortDirection = 'desc', firstPage = 1, limit = SHARED_CONSTANTS.MAX_PROGRAMS_PER_PAGE) =>
    queryOptions({
        queryKey: ['program-dashboard', { filters, sortBy, sortDirection, firstPage, limit }],
        queryFn: async () => {
            const response = await programsDashboardService.fetchPaginatedPrograms(firstPage, limit, filters, sortBy, sortDirection);
            // Response structure: { success: true, data: { programs: [...], total: X, totalPages: Y } }
            return response;
        },
        placeholderData: (previousData) => previousData, // Keep previous results while fetching
        ...programDashboardQueryOptions,
    });

export const getProgramStatsQueryOptions = () =>
    queryOptions({
        queryKey: ['program-stats'],
        queryFn: async () => {
            const response = await programsDashboardService.fetchProgramStats();
            // Response structure: { success: true, data: { activePrograms: X, totalVouchersCreated: Y, voucherRedemptionRate: Z } }
            return response;
        },
        ...programDashboardQueryOptions,
    });

/* Individual Program Query Options
 * @param {string} programId - ID of the program to fetch
 * @returns {object} Query options for fetching a single program's details
 * TODO Implement service function for fetching a single program
 **/
// export const getProgramQueryOptions = (programId) =>
//     queryOptions({
//         queryKey: ['programs', `program-${programId}`],
//         queryFn: programService.fetchProgram(programId),
//         enabled: !!programId,
//         staleTime: 10 * 60 * 1000, // 10 minutes
//         refetchOnWindowFocus: true,
//     });

// Customer Program Query Options
// export const getCustomerProgramAdminQueryOptions = (customerId, programId) =>
//     queryOptions({
//         queryKey: ['customer-program-admin', customerId, programId],
//         queryFn: ... // TODO: implement service function for fetching customer program admin status and use here instead of inline function --- IGNORE ---
//         enabled: !!customerId && !!programId,
//         staleTime: 0, // always fresh
//         refetchOnWindowFocus: true,
//     });
